import Styled from 'styled-components'
import { maxQuery } from '../../../helpers'

export default Styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 1rem;
    
    ${maxQuery('md')} {
        padding: 0 0.5rem;
    }
    
    header {
        margin-bottom: 3em;   
        ${maxQuery('md')} {
            margin-bottom: 2em;   
        }
        div.top--row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 8rem;
            h2 {
                color: #fff;
                font-size: 1.5rem;
                ${maxQuery('md')} {
                    font-size: 1.2rem;
                }
            }
            svg {
                ${maxQuery('sm')} {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        div.header--row {
            display: flex;
            align-items: center;
            margin-top: 2em;
            justify-content: space-between;
            ${maxQuery('md')} {
                flex-direction: column;
                justify-content: flex-start;
                align-items: stretch;
            }
            div.searchBar--container {
                max-width: 40rem;
                width: 100%;
                ${maxQuery('md')} {
                    max-width: 100%;
                }
                align-items: center;
            }
            button.add--btn {
                ${maxQuery('md')} {
                    margin-top: 1.2em;
                    align-self: flex-end;
                }
                display: flex;
                align-items: center;                
                background: #272B4A;
                border: 0.5px solid rgba(255, 255, 255, 0.08);
                box-sizing: border-box;
                border-radius: 4.02614px;
                color: ${({ theme }) => theme.primary};
                .icon {
                    margin-right: 0.2em;
                }
            }
        }
    }

    div.bikes--content__container {
        background: #272B4A;
        height: 100%;
        border: 0.765294px solid #272B4A;
        box-sizing: border-box;
        border-radius: 8.74621px;
        overflow-x: auto;
        
        ${maxQuery('md')} {
            border-radius: 4px;
        }
        
        /* Make table responsive */
        .ant-table-wrapper {
            ${maxQuery('md')} {
                font-size: 0.875rem;
            }
        }
        
        .ant-table {
            ${maxQuery('md')} {
                min-width: 600px;
            }
        }
        
        .ant-table-thead > tr > th {
            ${maxQuery('md')} {
                padding: 8px 4px;
                font-size: 0.75rem;
            }
        }
        
        .ant-table-tbody > tr > td {
            ${maxQuery('md')} {
                padding: 8px 4px;
                font-size: 0.875rem;
            }
        }
        
        /* Add blue hover effect to table rows */
        .ant-table-tbody > tr {
            transition: background-color 0.2s ease;
            cursor: pointer;
            
            &:hover {
                background-color: rgba(47, 89, 200, 0.15) !important;
            }
            
            &:hover > td {
                background-color: transparent !important;
            }
        }
        
        .action-container {
            position: relative;
            
            .action-popup {
                position: absolute;
                right: 0;
                top: 100%;
                background: #1a1d35;
                border: 1px solid rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                padding: 0.5rem 0;
                min-width: 120px;
                z-index: 10;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                
                ${maxQuery('md')} {
                    right: -10px;
                }
                
                button {
                    width: 100%;
                    padding: 0.5rem 1rem;
                    background: transparent;
                    border: none;
                    color: #fff;
                    text-align: left;
                    cursor: pointer;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.05);
                    }
                    
                    &.btn-delete {
                        color: #ff4444;
                    }
                }
            }
        }
    }
   
`
